var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { makeObservable, observable, runInAction } from 'mobx';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { EApiUrl } from '~/tools/api/types';
import { ThesaurusModel } from '~/models/thesaurus.model';
import { plainToInstance } from 'class-transformer';
import { t } from 'i18next';
export let ServiceThesaurus = class ServiceThesaurus extends BaseSingletonService {
    depositories;
    countries;
    locations;
    authors;
    physicalForms;
    stockages;
    stockageRefs;
    isCandidate = 0;
    communityId;
    constructor() {
        super();
        makeObservable(this);
        this.setCommunityId(17);
        this.getItems();
    }
    setCommunityId(communityId) {
        this.communityId = communityId;
    }
    searchLocations(countryId) {
        return this.locations?.filter(location => location.countryId === countryId) || [];
    }
    searchStockageRefs(stockageId) {
        return this.stockageRefs?.filter(stockage => stockage.stockageId === stockageId) || [];
    }
    get dateFormats() {
        return [
            { id: 'dd/mm/yyyy', value: 'dd/mm/yyyy', label: t('SEARCH_DATE_FORMAT_DATE') },
            { id: 'mm/yyyy', value: 'mm/yyyy', label: t('SEARCH_DATE_FORMAT_DATE_SHORT') },
            { id: 'yyyy', value: 'yyyy', label: t('SEARCH_DATE_FORMAT_DATE_YEAR') },
            { id: 'yyyy-yyyy', value: 'yyyy-yyyy', label: t('SEARCH_DATE_FORMAT_DATE_DOUBLE_YEAR') },
        ];
    }
    convertToOptions(thesaurusItems) {
        return (thesaurusItems
            ?.map(item => {
            return {
                id: item.id,
                label: item.name || item.description,
                value: item.id,
            };
        })
            .filter(item => !!item.label) || []);
    }
    getItems() {
        return new MobxQuery({
            queryFn: (() => api
                .get(`${EApiUrl.communities}/${this.communityId}/${EApiUrl.thesaurus}`, {
                params: {
                    is_candidate: this.isCandidate,
                },
            })
                .then(response => {
                runInAction(() => {
                    this.depositories = plainToInstance(ThesaurusModel, response.data?.model.depositories);
                    this.countries = plainToInstance(ThesaurusModel, response.data?.model.countries);
                    this.locations = plainToInstance(ThesaurusModel, response.data?.model.locations);
                    this.authors = plainToInstance(ThesaurusModel, response.data?.model.authors);
                    this.physicalForms = plainToInstance(ThesaurusModel, response.data?.model.physicalForms);
                    this.stockages = plainToInstance(ThesaurusModel, response.data?.model.stockages);
                    this.stockageRefs = plainToInstance(ThesaurusModel, response.data?.model.stockageReferences);
                });
            })),
        }).query();
    }
};
__decorate([
    observable,
    __metadata("design:type", Array)
], ServiceThesaurus.prototype, "depositories", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], ServiceThesaurus.prototype, "countries", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], ServiceThesaurus.prototype, "locations", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], ServiceThesaurus.prototype, "authors", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], ServiceThesaurus.prototype, "physicalForms", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], ServiceThesaurus.prototype, "stockages", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], ServiceThesaurus.prototype, "stockageRefs", void 0);
ServiceThesaurus = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [])
], ServiceThesaurus);
